import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type TranscriptSpeakerUnassignmentFailedAction = {
	type: 'TRANSCRIPT_SPEAKER_UNASSIGNMENT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): TranscriptSpeakerUnassignmentFailedAction => ({
	type: 'TRANSCRIPT_SPEAKER_UNASSIGNMENT_FAILED',
	payload,
});
